// extracted by mini-css-extract-plugin
module.exports = {"langBtn":"LanguageBtn_langBtn__1v8Q7"};